import { render } from "./container-details-analytics.vue?vue&type=template&id=7132ffc7&scoped=true"
import script from "./container-details-analytics.vue?vue&type=script&lang=js"
export * from "./container-details-analytics.vue?vue&type=script&lang=js"

import "./container-details-analytics.vue?vue&type=style&index=0&id=7132ffc7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7132ffc7"]])

export default __exports__